module.exports = __webpack_public_path__ + "static/media/18ECA11.568481d4.jpg";